import { createAction } from "@reduxjs/toolkit";
import { IContent, typeOrdersFilters } from "./reducer";
import { typePagination, typeRequestPagination } from "../system/constants";

const prefix = "D_ORDERS_ARCHIVE";

export const dOrdersArchiveSetPaginationAC = createAction(
  `${prefix}_SET_PAGINATION`,
  (pagination: typePagination) => ({ payload: { pagination } }),
);

export const dOrdersArchiveSetItemsForPageAC = createAction(
  `${prefix}_SET_ITEMS_FOR_PAGE`,
  (itemsForPage: number) => ({ payload: { itemsForPage } }),
);

export const dOrdersArchiveSetPageNumberAC = createAction(
  `${prefix}_SET_PAGE_NUMBER`,
  (pageNumber: number) => ({ payload: { pageNumber } }),
);

export const dOrdersArchiveSetDataAC = createAction(
  `${prefix}_SET_DATA`,
  (dataList: IContent[]) => ({ payload: { dataList } }),
);

export const dOrdersArchiveSetDataSagaAC = createAction(
  `${prefix}_SET_DATA_SAGA`,
  (filters: typeOrdersFilters, paginationRequest: typeRequestPagination) => ({
    payload: { filters, paginationRequest },
  }),
);

export const dOrdersArchiveSetDetailItemAC = createAction(
  `${prefix}_SET_DETAIL_ITEM`,
  (detailItemId: string) => ({ payload: detailItemId }),
);

export const dOrdersArchiveClearDetailItemAC = createAction(
  `${prefix}_CLEAR_DETAIL_ITEM`,
);

export const dOrdersArchiveClearFiltersAC = createAction(
  `${prefix}_CLEAR_FILTERS`,
);

export const dOrdersArchiveSetFiltersAC = createAction(
  `${prefix}_SET_FILTERS`,
  (filterObj: typeOrdersFilters) => ({ payload: filterObj }),
);
